import { readInt } from "../helpers.mjs";
import { ArgumentError } from "../../../utils/errors.mjs";
import { toBytes } from "../../../utils/bytes.mjs";
export default {
  serialize(value) {
    if (Number(value) < 0) throw new ArgumentError('value', 'greater or equal to 0', value);
    return toBytes(value, true);
  },
  deserialize(value) {
    return readInt(value);
  }
};
//# sourceMappingURL=u-int.mjs.map